<template>
  <div class="form-group h-full">
    <label class="tb-label layer-name">Shoppable Product</label>

    <div
      class="margin-bottom-md affiliate-controls h-full"
    >
      <div
        v-if="Object.keys(selectedProduct).length"
        class="margin-top-md"
      >
        <div class="flex">
          <img
            class="affiliate-image"
            :src="selectedProduct.image"
            alt="Product image"
            data-test="graphics-editor-shoppable-productImage"
          >
          <div class="overflow-hidden">
            <p
              class="cursor-default"
              :data-balloon="selectedProduct.name"
              data-balloon-pos="down"
              data-balloon-length="large"
            >
              <span
                class="tb-label"
              >
                Name
              </span>
              <span class="ellipsis--two-lines" data-test="graphics-editor-shoppable-name">{{ selectedProduct.name }}</span>
            </p>
            <p>
              <span class="tb-label">Price</span>
              <span class="ellipsis block" data-test="graphics-editor-shoppable-price">{{ selectedProduct.currentPrice }}</span>
            </p>
          </div>
        </div>

        
        <p>
          <span class="tb-label">Currency</span>
          <span class="ellipsis block" data-test="graphics-editor-shoppable-currency">{{ selectedProduct.currency }}</span>
        </p>
        <div v-if="shortenerEnabled" class="tb-form-group">
          <!-- TODO: Finalize copy for tooltip -->
          <p
            title="URL used by the QR Code to enable tracking of scans and more analytics."
            class="tb-label margin-bottom-none"
          >
            Short URL
  
            <copy-clipboard
              class="tb-btn sm tb-btn-text small-em"
              data-entity="producer-shoppableSettings-copyShortUrl"
              data-test="graphics-editor-shoppable-copyShortUrl"
              :data-clipboard-text="selectedProduct.shortUrl"
            >
              <span class="fas fa-link"></span>
            </copy-clipboard>
          </p>
  
          <span class="ellipsis" data-test="graphics-editor-shoppable-shortUrl">
            {{ selectedProduct.shortUrl }}
          </span>
        </div>
        <p
          class="cursor-default margin-bottom-none"
        >
          <span
            class="tb-label"
          >
            Full Product URL
            <a
              :href="selectedProduct.url"
              target="_blank"
              class="margin-left-xs high-em"
              data-test="graphics-editor-shoppable-copyFullUrl"
            ><span class="fas fa-external-link"></span></a>
          </span>
        </p>
        <p class="ellipsis" data-test="graphics-editor-shoppable-fullUrl">{{ selectedProduct.url }}</p>

        <button
          class="tb-btn tb-btn-contained medium-em"
          data-entity="producer-shoppableSettings-removeProduct"
          data-test="graphics-editor-shoppable-removeProduct"
          @click="removeProduct"
        >
          Remove
        </button>
      </div>

      <div
        v-else
        class="flex flex-column content-center items-center w-full h-full text-center"
      >
        <div>
          <p>Browse the catalog to find items.</p>
          <p>Save them to your collection, then switch to the Shoppable Tab to drag and drop items into the drop zone on your timeline.</p>
          <button
            class="tb-btn tb-btn-contained medium-em"
            data-entity="producer-shoppableSettings-browseCatalog"
            data-test="graphics-editor-shoppable-browseCatalog"
            @click="openCatalogModal"
          >
            <span class="far fa-cart-plus"></span>
            Browse Catalog
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import CopyClipboard from '@/js/shared/copy-clipboard/CopyClipboard.vue';

export default {
  props: ['graphic', 'element', 'graphic_fields'],
  components: {
    CopyClipboard,
  },

  data() {
    return {
      shortenerEnabled: process.env.QR_CODE_SWITCH === 'ON',
    };
  },

  computed: {
    ...mapState({
      production(state) {
        return state.production.production;
      },
    }),
    computedFields() {
      return (
        this.graphic.fields?.[this.element.id]
        || this.graphic_fields?.[this.element.id]
      ) ?? {};
    },

    data: {
      get() {
        return this.computedFields.data ?? this.element.data;
      },

      set(value) {
        this.$emit('value', { value, field: 'data' });
      },
    },

    selectedProduct() {
      return this.data?.selectedProduct ?? {};
    },
  },
  methods: {
    ...mapActions('shoppable', ['openCatalogModal']),
    removeProduct() {
      this.data = {
        type: null,
        selectedProduct: {},
      };
    },
  },
};
</script>
